import REF_CODE from '~/shared/cookies/REF_CODE';
import Cookie from '~/shared/utils/Cookie';
import sanitizeCookie from './utils/sanitizeCookie';

const useRefCode = () => sanitizeCookie(Cookie.get(REF_CODE) as string);

export default useRefCode;
